export default "__VITE_ASSET__CYhOwk0j__"